import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Report from './views/Report.vue'
import ViewReport from './views/ViewReport.vue'
import Login from './views/Login.vue'
import Clients from './views/Clients.vue'
import Content from './views/Content.vue'
import AccountView from './views/AccountView.vue'
import AdminUsers from './views/AdminUsers.vue'
import ActivityHistory from './views/ActivityHistory.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/report/:id/:time',
      name: 'Report',
      component: Report,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/view-report/:id/:time',
      name: 'View Report',
      component: ViewReport,
      meta: {
          requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/clients',
      name: 'Clients',
      component: Clients,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/content',
      name: 'Content',
      component: Content,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/account-view/:id',
      name: 'AccountView',
      component: AccountView,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/admin-users',
      name: 'AdminUsers',
      component: AdminUsers,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/activity-history',
      name: 'ActivityHistory',
      component: ActivityHistory,
      meta: {
          requiresAuth: true
      }
    }
  ]
})
// CAN ADD 'ACTIVE' STATE ROUTE BLOCK FOR DOUBLE SECURITY FROM VUEX